(function ($) {
    'use strict';

    var SELECTOR = '[data-revision-request]';
    var PREVIEW_SELECTOR = '[data-revision-request-preview]';
    var SELECTOR_REVISION_FORM = 'form[data-revision-form]';
    var PREVIEW_PAGINATION_SELECTOR = '[data-preview-pagination]';

    var $body = $('body');

    var RevisionRequest = {};

    RevisionRequest.onClickChangeTab = function (event) {
        event.preventDefault();

        var $element = $(this),
            $selector = $element.closest(SELECTOR),
            $tab = $selector.find($element.attr('data-change-tab')),
            $previewPagination = $body.find(SELECTOR+' '+PREVIEW_PAGINATION_SELECTOR);

        setTimeout(function () {
            $previewPagination.responsivePagination('refresh');
        }, 400);


        $tab.removeClass('disabled');
        $tab.tab('show');

        setTimeout(function () {
            $(window).scrollTop($tab.scrollTop());
        }, 200);
    };

    RevisionRequest.onKeyupVerificationCode = function (event) {
        var $element = $(this),
          currentValue = $element.val();

        $element.val(currentValue.toUpperCase());
    };

    RevisionRequest.onBlurVerificationCode = function (event) {
        var $element = $(this),
          currentValue = $element.val();

        if (! $element.val().match(/^[cC]-?([0-9]{1,6})?$/)) {
            $element.val('');
        }
    };

    RevisionRequest.onKeypressVerificationCode = function (event) {
        var $element = $(this),
          currentValue = $element.val(),
          newValue = currentValue + String.fromCharCode(event.charCode),
          index = currentValue.length;

        if (newValue.length > 7) {
            return false;
        }

        if (! newValue.match(/^[cC]-?([0-9]{1,6})?$/)) {
            return false;
        }
    };

    RevisionRequest.safeChangePreviewPage = function (page) {
        var $selector = $body.find(SELECTOR),
            $preview = $selector.find(PREVIEW_SELECTOR);

        $preview.data('revision-request.current-page', page);

        $preview.trigger('refresh.revision-request');
    }

    RevisionRequest.onRefreshPreview = function (event) {
        var $preview = $(this),
            $selector = $preview.closest(SELECTOR),
            revisionRequestId =$selector.data('revision-request'),
            revisionToken = $selector.data('revision-token'),
            apiUrl = $selector.data('api-url');

        if ($preview.data('revision-request-preview.state')) {
            return;
        }

        $preview.data('revision-request-preview.state', 'initialization');
        $preview.addClass('is-loading');

        $.ajax(apiUrl+'v1/revision-requests/'+revisionRequestId+'/document/page-previews/', {
            'headers': {
                'X-Revision-Token': revisionToken
            }
        })
            .done(function(data) {
                $preview.data('revision-request-preview.state', null);
                $preview.removeClass('is-loading');

                $preview.data('revision-request-preview.data', data);
                RevisionRequest.buildPreviewPagination();
                RevisionRequest.changePreviewPage($preview.data('revision-request.current-page') || 1);
            })
            .always(function () {
                $preview.data('revision-request-preview.state', null);
                $preview.removeClass('is-loading');
            })
        ;
    };

    RevisionRequest.buildPreviewPagination = function () {
        var $preview = $body.find(SELECTOR+' '+PREVIEW_SELECTOR),
            $previewPagination = $body.find(SELECTOR+' '+PREVIEW_PAGINATION_SELECTOR),
            $previewPaginationList = $previewPagination.find('ul').first(),
            previewData = $preview.data('revision-request-preview.data'),
            seenPages = $preview.data('revision-request.seen-pages') || [];

        var $cursor = $previewPaginationList.children().first(),
            $pageItem,
            preview;

        $previewPaginationList.find('[data-page-item="page"]').remove();

        for (var i = 0; i < previewData.meta.count; i++) {
            preview = previewData.data[i];
            $pageItem = $('<li class="page-item" data-page-item="page"><a class="page-link'+(seenPages.includes(preview.page) ? ' is-checked' : '')+'" href="#" data-preview-page="'+preview.page+'">'+preview.page+'<span class="page-checkmark"><svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#checkmark-filter0_ddd-'+i+')"><circle cx="13" cy="12" r="8" fill="#FBDFE4"/></g><path d="M17 9.63L11.514 15 9 12.54l.645-.632 1.87 1.826L16.354 9l.645.63z" fill="#E61B3E"/><defs><filter id="checkmark-filter0_ddd-'+i+'" x="0" y="0" width="26" height="26" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation="2.5"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/><feBlend in2="effect1_dropShadow" result="effect2_dropShadow"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend in2="effect2_dropShadow" result="effect3_dropShadow"/><feBlend in="SourceGraphic" in2="effect3_dropShadow" result="shape"/></filter></defs></svg></span></a></li>');
            $pageItem.insertAfter($cursor);
            $cursor = $pageItem;
        }
    };

    RevisionRequest.onClickPreview = function (event) {
        event.preventDefault();

        var $preview = $(this);

        if (! $preview.data('revision-request-preview.loaded')) {
            return;
        }

        window.open($preview.attr('src'), '_blank');
    };

    RevisionRequest.onClickPreviewPage = function (event) {
        var $element = $(this),
            page = $element.data('preview-page');

        RevisionRequest.safeChangePreviewPage(page);
    };

    RevisionRequest.changePreviewPage = function (page) {
        var $selector = $body.find(SELECTOR),
            $preview = $selector.find(PREVIEW_SELECTOR),
            $previewPagination = $body.find(SELECTOR+' '+PREVIEW_PAGINATION_SELECTOR),
            $pagePreview = $previewPagination.find('[data-preview-page="' + page + '"]'),
            apiUrl = $selector.data('api-url'),
            previewData = $preview.data('revision-request-preview.data'),
            seenPages = $preview.data('revision-request.seen-pages') || [],
            pagePreview;

        $preview.data('revision-request.current-page', page);

        if ($pagePreview.data('revision-request-preview.src')) {
            $preview.attr('src', $pagePreview.data('revision-request-preview.src'));
            $previewPagination.find('[data-preview-page]').removeClass('is-active');
            $pagePreview.addClass('is-active');

            RevisionRequest.updateNavigation();

            return;
        }

        for (var i = 0; i < previewData.meta.count; i++) {
            if (previewData.data[i].page === parseInt(page)) {
                pagePreview = previewData.data[i];
                break;
            }
        }

        if ($preview.data('revision-request-preview.state')) {
            return;
        }

        if (! pagePreview && page !== 1) {
            RevisionRequest.changePreviewPage(1);
        }

        $preview.data('revision-request-preview.state', 'loading');
        $preview.addClass('is-loading');

        $.ajax(apiUrl.replace(/\/api\/$/, '') + pagePreview.file.location, {
            headers: {
                'X-Revision-Token': $selector.data('revision-token'),
                'X-Revision-Request': $selector.data('revision-request')
            },
            cache:false,
            xhrFields:{
                responseType: 'blob'
            },
            success: function(data){
                $preview.data('revision-request-preview.state', null);
                $preview.removeClass('is-loading');

                var url = window.URL || window.webkitURL;
                var src = url.createObjectURL(data);

                $preview.attr('src', src);

                $pagePreview.addClass('is-checked');

                $previewPagination.find('[data-preview-page]').removeClass('is-active');
                $pagePreview.addClass('is-active');
                $pagePreview.focus();
                window.scrollTo(0, 0);
                $pagePreview.data('revision-request-preview.src', src);
                $preview.data('revision-request-preview.loaded', true);

                seenPages.push(page);
                $preview.data('revision-request.seen-pages', seenPages);

                RevisionRequest.updateNavigation();
                RevisionRequest.updateRevisionForm();
            },
            error: function () {
                console.error('Page preview error');
            },
            complete: function () {
                $preview.data('revision-request-preview.state', null);
                $preview.removeClass('is-loading');
            }
        });
    };

    RevisionRequest.updateNavigation = function () {
        var $previewPagination = $body.find(SELECTOR+' '+PREVIEW_PAGINATION_SELECTOR),
            $previewPreviousPage = $previewPagination.find('[data-preview-pagination-previous]'),
            $previewNextPage = $previewPagination.find('[data-preview-pagination-next]'),
            $previewPages = $previewPagination.find('[data-preview-page]'),
            $previewPage = $previewPages.filter('.is-active').first(),
            page = $previewPage.data('preview-page');

        $previewPreviousPage.toggleClass('disabled', page <= 1);
        $previewNextPage.toggleClass('disabled', page >= $previewPages.length);

        $previewPagination.responsivePagination('refresh');
    };

    RevisionRequest.onClickPreviewPreviousPage = function (event) {
        var $previewPreviousPage = $(this),
            $previewPagination = $previewPreviousPage.closest(PREVIEW_PAGINATION_SELECTOR),
            $previewPages = $previewPagination.find('[data-preview-page]'),
            $previewPage = $previewPages.filter('.is-active').first(),
            page = $previewPage.data('preview-page'),
            previousPage = page <= 1 ? 1 : page - 1;

        if ($previewPreviousPage.hasClass('disabled')) {
            event.preventDefault();
            return;
        }

        RevisionRequest.safeChangePreviewPage(previousPage);
    };

    RevisionRequest.onClickPreviewNextPage = function (event) {
        var $previewNextPage = $(this),
            $previewPagination = $previewNextPage.closest(PREVIEW_PAGINATION_SELECTOR),
            $previewPages = $previewPagination.find('[data-preview-page]'),
            $previewPage = $previewPages.filter('.is-active').first(),
            page = $previewPage.data('preview-page'),
            nextPage = page >= $previewPages.length ? $previewPages.length : page + 1;

        if ($previewNextPage.hasClass('disabled')) {
            event.preventDefault();
            return;
        }

        RevisionRequest.safeChangePreviewPage(nextPage);
    };

    RevisionRequest.onChangeRevisionForm = function (event) {
        event.preventDefault();

        if (event.isTrigger) {
            return;
        }

        RevisionRequest.updateRevisionForm();
    };

    RevisionRequest.updateRevisionForm = function () {
        var $selector = $body.find(SELECTOR),
            $previewPagination = $body.find(SELECTOR+' '+PREVIEW_PAGINATION_SELECTOR),
            $previewPages = $previewPagination.find('[data-preview-page]'),
            $revisionForm = $selector.find(SELECTOR_REVISION_FORM),
            $revisionButton = $selector.find('[data-revision-button]'),
            $revisionReadyAlert = $selector.find('[data-revision-ready="true"]'),
            $revisionNotReadyAlert = $selector.find('[data-revision-ready="false"]'),
            $checkedPreviewPages = $previewPages.filter('.is-checked'),
            isValidRevisionForm = $revisionForm.get(0).checkValidity(),
            revisionFormEnabled = $previewPages.length > 0 && $previewPages.length === $checkedPreviewPages.length;
            if (revisionFormEnabled) {
                $revisionNotReadyAlert.hide();
                $revisionReadyAlert.show();
                $revisionButton
                    .prop('disabled', ! isValidRevisionForm)
                    .toggleClass('disabled', ! isValidRevisionForm);
            }
    };

    RevisionRequest.onSubmitRevisionForm = function (event) {
        event.preventDefault();

        var $revisionForm = $(this),
            $selector = $revisionForm.closest(SELECTOR),
            $messagesContainers = $revisionForm.find('[data-form-field-error]');

        if ($revisionForm.data('async-state')) {
            return;
        }

        $revisionForm.data('async-state', 'loading');
        $revisionForm.addClass('loading');

        // Clear errors
        $messagesContainers.html('');

        var formData = $revisionForm.serializeArray();

        $.ajax($revisionForm.attr('action'), {
            data: formData,
            method: $revisionForm.attr('method')
        })
            .done(function (response) {
                if (! response.ok) {
                    if (! response.errors) {
                        console.error('Unknow error');
                    }

                    if (response.errors.already_responded_revision_request) {
                        window.scrollTo(0, 0);
                        window.location.reload();
                    }

                    $.each(response.errors, function (field, messages) {
                        var $messagesContainer = $revisionForm.find('[data-form-field-error="'+field+'"]'),
                            $messagesList = $('<ul />');

                        $.each(messages, function (type, message) {
                            $messagesList.append('<li>' + message + '</li>');
                        });

                        $messagesContainer.html($messagesList);
                    });

                    $revisionForm.data('async-state', null);
                    $revisionForm.removeClass('loading');

                    return;
                }

                var data = response.data,
                    token = data.token,
                    revisionRequestId = data.revision_request,
                    apiUrl = $selector.data('api-url');

                delete data.token;
                delete data.revision_request;

                $.ajax(apiUrl+'v1/revision-requests/'+revisionRequestId+'/revision-responses/', {
                    'headers': {
                        'X-Revision-Token': token
                    },
                    method: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(data)
                })
                    .done(function(response) {
                         if (! response.data.response) {
                            console.error('Unknow error');
                        }

                        sessionStorage.setItem('revision-request.submitted', 'done');
                        window.scrollTo(0, 0);
                        window.location.reload();
                    })
                    .fail(function () {
                        console.error('Api Error');
                    })
                    .always(function () {
                        $revisionForm.data('async-state', null);
                        $revisionForm.removeClass('loading');
                    })
                ;
            })
            .fail(function(jqXHR, textStatus) {
                $revisionForm.data('async-state', null);
                $revisionForm.removeClass('loading');
            })
        ;
    };

    $(document).ready(function () {
        $body.on('click.revision-request', SELECTOR + ' [data-change-tab]', RevisionRequest.onClickChangeTab);
        $body.on('keyup.revision-request', SELECTOR + ' [data-form-control="verification_code"]', RevisionRequest.onKeyupVerificationCode);
        $body.on('keypress.revision-request', SELECTOR + ' [data-form-control="verification_code"]', RevisionRequest.onKeypressVerificationCode);
        $body.on('blur.revision-request', SELECTOR + ' [data-form-control="verification_code"]', RevisionRequest.onBlurVerificationCode);
        $body.on('refresh.revision-request', SELECTOR + ' ' + PREVIEW_SELECTOR, RevisionRequest.onRefreshPreview);
        $body.on('change.revision-request', SELECTOR + ' ' + SELECTOR_REVISION_FORM, RevisionRequest.onChangeRevisionForm);
        $body.on('submit.revision-request', SELECTOR + ' ' + SELECTOR_REVISION_FORM, RevisionRequest.onSubmitRevisionForm);
        $body.on('click.revision-request', SELECTOR + ' ' + PREVIEW_SELECTOR, RevisionRequest.onClickPreview);
        $body.on('click.revision-request', SELECTOR + ' ' + PREVIEW_PAGINATION_SELECTOR + ' [data-preview-pagination-previous]', RevisionRequest.onClickPreviewPreviousPage);
        $body.on('click.revision-request', SELECTOR + ' ' + PREVIEW_PAGINATION_SELECTOR + ' [data-preview-pagination-next]', RevisionRequest.onClickPreviewNextPage);
        $body.on('click.revision-request', SELECTOR + ' ' + PREVIEW_PAGINATION_SELECTOR + ' [data-preview-page]', RevisionRequest.onClickPreviewPage);
        $body.find(SELECTOR + ' ' + PREVIEW_SELECTOR).trigger('refresh.revision-request');

        var $selector = $body.find(SELECTOR);
        var $previewPagination = $selector.find(PREVIEW_PAGINATION_SELECTOR);

        $previewPagination.responsivePagination({
            getPageItemCallback: function(page, instance) {
                var $element = $(instance.element),
                    $link = $element.find('[data-preview-page="'+page+'"]');

                return $link.parent();
            },
            getCurrentPageCallback: function(instance) {
                var $element = $(instance.element);

                return $element.find('.is-active').data('preview-page');
            }
        });

        var $revisionResponseValue = $body.find('[data-revision-response-value]')
        var $revisionResponseNote = $body.find('[data-revision-response-note]');
        $revisionResponseValue.on('change', function() {
            if ($(this).val() === 'approved') {
                $revisionResponseNote.prop('required', false).closest('.form-group').hide();
            } else {
                $revisionResponseNote.prop('required', true).closest('.form-group').show();
            }
        });

        if (sessionStorage.getItem('revision-request.submitted') === 'done') {
            sessionStorage.removeItem('revision-request.submitted');
            $selector.find('[data-revision-request-success]').show();
        }
    });

})(require('jquery'));
